// Gravity Forms file upload feedback
//
// The native file input is invisible (see _form.scss), so the browser's own
// "file chosen" text never shows. Flag the container once a file is picked
// and expose the filename for the CSS prompt to display instead.
// Delegated on document so it survives Gravity Forms' AJAX re-renders.

document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'file') return;

    const container = input.closest('.ginput_container_fileupload');
    if (!container) return;

    const file = input.files && input.files[0];

    container.classList.toggle('is-filled', Boolean(file));

    if (file) {
        container.dataset.fileName = file.name;
    } else {
        delete container.dataset.fileName;
    }
});
